/**
 * 来款登记
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/5/17      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */


import React from 'react'
import PropTypes from "prop-types";
import {Spin, Button, } from "antd";
import Add from "./components/Add";
import CommonBreadcrumb from "../../../components/CommonBreadcrumb";
import AutoFetchTable from "@components/AutoFetchTable/AutoFetchTable";
import { Link } from "react-router-dom";
import "./index.less";
import {getColumnsIn} from "../component/PaymentColumns";


class PaymentCheckIn extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            //加载中
            loading: false,
            //数据源
            list: [],
            pageSize: 10,
            pageIndex: 1,
            total: 0,
            extra: {},
            isVisible:false,
            // 列
            columns: getColumnsIn(),
        }
    }


    /**
     * 切换分页
     * @param page 切换到第几页
     * @param pageSize
     **/
    // onChangePage = (page, pageSize) => {
    //     this.getData(page, pageSize);
    // };

    /**
     * 获取数据
     **/
    // getData(pageIndex, pageSize) {
    //     this.setState(
    //         {
    //             loading: true,
    //         },
    //         () => {
    //             let postData = {
    //                 pagingQuery: {
    //                     pageIndex: pageIndex || this.state.pageIndex,
    //                     pageSize: pageSize || this.state.pageSize,
    //                 },
    //             };
    //
    //             $.ajax({
    //                 url: "/service/mg/fin/ddp/remittance-item/remittanceList",
    //                 type: "post",
    //                 dataType: "json",
    //                 contentType: "application/json",
    //                 data: JSON.stringify(postData),
    //                 success: (res) => {
    //                     let data = {
    //                         loading: false,
    //                     };
    //                     if (res.success && res.valid) {
    //                         res.models.map(function (item, index) {
    //                             item.key = index;
    //                         });
    //                         data = Object.assign(data, {
    //                             list: res.models || [],
    //                             extra: res.extra || {},
    //                         });
    //                     }
    //                     //分页
    //                     if (res.paging) {
    //                         data = Object.assign(data, {
    //                             pageIndex: res.paging.pageNum,
    //                             pageSize: res.paging.pageSize,
    //                             total: res.paging.total,
    //                         });
    //                     }
    //                     this.setState(data);
    //                 },
    //                 error: () => {
    //                     let data = {
    //                         loading: false,
    //                     };
    //                     this.setState(data);
    //                 },
    //             });
    //         }
    //     );
    // }

    getData(){
        this.onRefTabChildOne.handleFetch(1,{},true)
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    componentDidMount() {
        // this.getData();
    }



    render(){
        const { loading, list ,columns} = this.state;
        return (
            <div className="payment-check-in-wrap">
                <CommonBreadcrumb
                    list={[{ name:__getServerLanguage('LaiKuanDengJi') }]}
                ></CommonBreadcrumb>

                <div className="main-wrap">
                    <span className="title font_18 fw_700">{__getServerLanguage('LaiKuanDengJi')}</span>
                    <Add callBack={this.getData.bind(this,1)}></Add>
                </div>

                <Spin spinning={loading}>
                    <div className="main-wrap">
                        <div className="title flex-title">
                            <span>{__getServerLanguage('JinQiLaiKuan')}</span>
                            <Link to={`/financeManagement/paymentCheckIn-record`}>
                                <Button danger shape="round">
                                    {__getServerLanguage('ChaKanLaiKuanJiLu')}
                                </Button>
                            </Link>
                        </div>

                        {/*表格*/}
                        {/*<div className="content-wrap">*/}
                            {/*<List list={list}></List>*/}
                        {/*</div> */}
                        <AutoFetchTable columns={columns}
                                        onRef={this.onRefTabOne}
                                        scroll={{ x: 1200 }}
                                        pageSize={10}
                                        paginationFlag={false}
                                        fetchApi={'/service/mg/fin/ddp/remittance-item/remittanceList'}>
                        </AutoFetchTable>
                    </div>
                </Spin>
            </div>
        )
    }
}

PaymentCheckIn.defaultProps = {
}

PaymentCheckIn.propTypes = {

}
export default PaymentCheckIn;
